//const newApiUrl = 'https://localhost:44361/api/Pages';
const newApiUrl = 'https://mm_cms.emis-online.sk/cms/web_cms_apigateway/api/Pages';

export default {
    getPageBySeoId(axios, {seoId}) {
        return axios.get(`${newApiUrl}/pages/${seoId}?tag=true&attachment=true&meta=true`)
            .then(response => {
                return response.data;
            });
    },
    getLinksByTag(axios, {tag, limit = 5}) {
        return axios.get(`${newApiUrl}/pages/tag/${tag}/links?limit=${limit}`)
            .then(response => {
                return response.data;
            });
    },
    searchInHelpPages(axios, {searchValue}) {
        return axios.get(`${newApiUrl}/pages/tag/HELP_PAGE/search?search=${searchValue}&tags=true`)
            .then(response => {
                return response.data;
            });
    },
    getPricingPackages(axios) {
        return axios.get(`${newApiUrl}/pages/pricing-1`)
            .then(response => {
                return response.data;
            });
    },
    getNews(axios, {tag, limit = 2, offset = 0}) {
        return axios.get(`${newApiUrl}/pages/tag/${tag}?limit=${limit}&offset=${offset}`)
            .then(response => {
                return response.data;
            });
    },
    getWorkshops(axios, {limit = 2, offset = 0}) {
        return axios.get(`${newApiUrl}/pages/tag/WORKSHOP?limit=${limit}&offset=${offset}`)
            .then(response => {
                return response.data;
            });
    }
}